import { render, staticRenderFns } from "./installPrompt.vue?vue&type=template&id=ef0ef6fc&"
import script from "./installPrompt.vue?vue&type=script&lang=js&"
export * from "./installPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports